import { NEXT_PUBLIC_SHOP_API_URL } from '@/configs/env'
import axios from 'axios'
import queryString from 'query-string'

const axiosService = axios.create({
  baseURL: `${NEXT_PUBLIC_SHOP_API_URL}`,
  headers: {
    'content-type': 'application/json',
  },
  paramsSerializer: (params: Record<string, unknown>) => queryString.stringify({ ...params }),
  proxy: false,
})

export default axiosService
